<p>issue-contract-report works!</p>
